import BillingV1Adapter from './billing-v1';

export default class BillingV2Adapter extends BillingV1Adapter {
  namespace = 'v2';
}
